var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-wrapper",class:[{ isLoading: _vm.isLoading }]},[(_vm.hasError)?_c('placeholder'):_c('div',{class:[_vm.generateSliderClass]},_vm._l((_vm.sliderContent.slides),function(slide){return _c('div',{key:slide.index},[_c('slide',{attrs:{"content":slide}})],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16d57a7c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/slider/Slider.vue
// module id = 229
// module chunks = 0